import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { OperadorasActions, UserProfileActions } from '@gestor-web/@core/store/actions';
import { OperadorasSelectors, UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { primeNgPtBR } from '@gestor-web/app/shared/modules';
import {
  ClarityScriptService,
  CookieConsentService,
  GeralService,
  LoaderService,
  PosthogScriptService,
} from '@gestor-web/app/shared/services';
import { GridService } from '@gestor-web/app/shared/services/grid.service';
import { LicenseManager } from 'ag-grid-enterprise';
import { PrimeNG } from 'primeng/config';
import { combineLatest } from 'rxjs';
import { filter, skipWhile, switchMap } from 'rxjs/operators';

const AG_GRID_LICENSE =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-097748}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{BLENDUS_Tecnologia_em_Sade}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Gestor_IDSS}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Gestor_IDSS}_need_to_be_licensed___{Gestor_IDSS}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_April_2027}____[v3]_[01]_MTgwNzQ4NDQwMDAwMA==53bb6b87bdfac3c83d1d089e937be296';

@Component({
    selector: 'app-root',
    template: `
    <router-outlet></router-outlet>

    <!-- Um unico ConfirmDialog no shell atende todas as telas; labels especificos vao na chamada do confirm(). -->
    <p-confirmDialog
      [style]="{ width: '500px' }"
      [baseZIndex]="10000"
      acceptIcon="pi pi-check"
      rejectIcon="pi pi-times"
      rejectButtonStyleClass="p-button-outlined"
    ></p-confirmDialog>
  `,
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private store: Store,
    private geralService: GeralService,
    private gridService: GridService,
    private loadService: LoaderService,
    private primengConfig: PrimeNG,
    private posthogService: PosthogScriptService,
    private clarityService: ClarityScriptService,
    // private zendeskService: ZendeskScriptService,
    private cookieConsentService: CookieConsentService,
    private router: Router,
  ) {
    primengConfig.setTranslation(primeNgPtBR);
    primengConfig.ripple.set(true);

    LicenseManager.setLicenseKey(AG_GRID_LICENSE);

    /* Use para debugar eventos de navegação
    this.router.events.pipe(filter(event => event instanceof NavigationCancel)).subscribe((event: NavigationCancel) => {
      console.warn(`Navigation canceled: ${event.reason}`, event); // Debug string reason

      if (event.code === NavigationCancellationCode.GuardRejected) {
        // Handle the specific case of a guard rejecting the navigation
        console.log('Reason Code: Guard Rejected');
      }
    });
    */
  }

  ngOnInit() {
    this.store.dispatch(UserProfileActions.getFullProfile());
    this.store.dispatch(OperadorasActions.getOperadoras());
    this.geralService.fetchDominios();
    this.gridService.fetchVisoes();

    this.cookieConsentService.checkCookies();

    // After initial loading, cancel pending requests when navigating to a page
    combineLatest([
      this.store.select(UserProfileSelectors.selectUserProfile),
      this.store.select(OperadorasSelectors.selectOperadorasLoaded),
      this.geralService.getDominiosLoaded(),
      this.gridService.getVisoesLoaded(),
    ])
      .pipe(
        // tap(_ => console.log('[App] wait for initial data loaded', _)),
        skipWhile(
          ([{ kc_loaded, idss_loaded }, operadora_loaded, dominios_loaded, visoes_loaded]) =>
            !(kc_loaded && idss_loaded && operadora_loaded && dominios_loaded && visoes_loaded),
        ),
        // tap(_ => console.log('[App] all initial data loaded', _)),
        switchMap(() => this.router.events),
        filter(event => event instanceof NavigationStart),
        // tap(_ => console.log('[App] router event :: NavigationStart => Cancel Pending Requests', _)),
      )
      .subscribe(() => this.loadService.cancelPendingRequests());
  }
}
